export default function Reducer(state, action) {
  switch (action.type) {
    case 'SELECT_MEMBERS':
      return {
        ...state,
        selectedMembers: action.memberIds,
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
